"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSyncStatus = void 0;
var AppSyncStatus;
(function (AppSyncStatus) {
    AppSyncStatus["INITIALIZING"] = "initializing";
    AppSyncStatus["CONNECTED"] = "connected";
    AppSyncStatus["CLOSED"] = "closed";
    AppSyncStatus["ERROR"] = "error";
})(AppSyncStatus = exports.AppSyncStatus || (exports.AppSyncStatus = {}));
//# sourceMappingURL=AppSyncStatus.js.map